define('model/CompanyTimeZoneModel',['require','model/TimeZoneModel'],function (require) {

    var TimeZoneModel = require('model/TimeZoneModel');

    return TimeZoneModel.extend({

        url: '/time-zone/company/'

    });

});
